export default "__VITE_ASSET__CyMCE9Pn__"